import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';

import Header from '../Header/Header';
import Message from '../Message/Message';

function Layout(props) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        ...props.rootSx,
      }}
    >
      {props.showHeader ? (
        <Header
          transparent={props.transparent}
          reverse={props.reverse}
          leftNav={props.leftNav}
          rightNav={props.rightNav}
          hasReturn={props.returnLinkTo && props.returnLinkText}
        />
      ) : null}
      {props.secondaryNav ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            bgcolor: 'white',
            borderBottom: '1px solid #e0e0d9',
            minHeight: 54,
            px: 2,
            '& .layout-secondary-inner': {
              flex: '1 0 auto',
              maxWidth: 1280,
              margin: '0 auto',
              p: 0,
              width: '100%',
            },
          }}
        >
          <Box className="layout-secondary-inner">{props.secondaryNav}</Box>
        </Box>
      ) : null}
      {props.backContent || (props.returnLinkTo && props.returnLinkText) ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            bgcolor: 'white',
            borderBottom: '1px solid #e0e0d9',
            minHeight: 36,
            px: 4,
            '& .layout-back-inner': {
              flex: '1 0 auto',
              maxWidth: 1280,
              margin: '0 auto',
              p: 0,
              width: '100%',
            },
            '& .layout-back-link': {
              fontSize: 14,
              fontWeight: 300,
              bgcolor: 'transparent',
              color: '#868682',
              border: 'none',
              position: 'relative',
              textDecoration: 'none',
              ml: '-15px',
              cursor: 'pointer',
              '&::before': {
                content: '"\\27E8"',
                mr: '10px',
              },
            },
          }}
        >
          <Box className="layout-back-inner">
            {!props.backContent || props.backContent}
            {!props.backContent &&
              (!props.backContent && props.returnLinkTo === 'back' ? (
                <Box
                  component="button"
                  className="layout-back-link"
                  type="button"
                  onClick={() => navigate(-1)}
                  tabIndex="0"
                >
                  {props.returnLinkText}
                </Box>
              ) : (
                <Link className="layout-back-link" to={props.returnLinkTo}>
                  {props.returnLinkText}
                </Link>
              ))}
          </Box>
        </Box>
      ) : null}
      {props.error ? <Message type="error" msg={props.error} onClose={props.setError} /> : null}
      {props.ok ? <Message type="ok" msg={props.ok} onClose={props.setOk} /> : null}

      {props.info ? <Message type="info" msg={props.info} onClose={props.setInfo} /> : null}
      <Box
        id="content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 0 auto',
          bgcolor: 'background.body',
          ...(!props.disableGutters && { px: 2 }),
        }}
      >
        {props.children}
      </Box>
      <Footer />
    </Box>
  );
}

Layout.defaultProps = {
  leftNav: null,
  rightNav: null,
  children: null,
  returnLinkTo: null,
  returnLinkText: null,
  className: null,
  rootSx: null,
  showHeader: true,
  error: null,
  setError: null,
  ok: null,
  setOk: null,
  info: null,
  setInfo: null,
  secondaryNav: null,
  disableGutters: false,
  backContent: null,
  reverse: false,
};

Layout.propTypes = {
  children: PropTypes.any,
  leftNav: PropTypes.object,
  rightNav: PropTypes.object,
  returnLinkTo: PropTypes.string,
  returnLinkText: PropTypes.string,
  className: PropTypes.string,
  rootSx: PropTypes.object,
  showHeader: PropTypes.bool,
  error: PropTypes.object,
  ok: PropTypes.object,
  setError: PropTypes.func,
  setOk: PropTypes.func,
  info: PropTypes.object,
  setInfo: PropTypes.func,
  secondaryNav: PropTypes.node,
  disableGutters: PropTypes.bool,
  backContent: PropTypes.node,
  reverse: PropTypes.bool,
};

export default Layout;
